export interface IDocumentItem {
  documentType: DocumentType;
  title: string;
  url: string;
  description?: string | null;
  urlText?: string | null;
  tracePartsPartId?: string | null;
}

export enum DocumentType {
  Pdf = 'PDF',
  RohsCompliance = 'ROHSCompliance',
  ConformityStatement = 'ConformityStatement',
  TraceParts3DCad = 'TraceParts3DCad',
  ElrProductInformationSheet = 'ElrProductInformationSheet',
}
